export default "__VITE_ASSET__wZ_EZ$$K__"